import { createSelector } from 'reselect'

const getState = state => state.YearGroups

const getYearGroups = state => getState(state).yearGroups

const getFilteredYearGroups = createSelector(
  [getYearGroups],
  yearGroups =>
    !yearGroups
      ? null
      : yearGroups.filter(group => group.order > 1 && group.order !== 15)
)

export { getYearGroups, getFilteredYearGroups }
